import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import { useHubSpotChatRefresh } from '../hooks/use-hubspot-chat-refresh'

export const AppRoot: React.FC = () => {
  useHubSpotChatRefresh()

  return (
    <>
      <Helmet>
        {/* TODO: Clarityのタグはblade側に寄せる */}
        <script type="text/javascript">
          {/* {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "mmyk69swqb");
          `} */}
        </script>
      </Helmet>
      <Outlet />
    </>
  )
}
